module.exports = __webpack_public_path__ + "media/images/profile/cross-09fb6c2425c2c8e1b2f6e961f5104eac.svg";